import { CustomLink } from '@/components/custom-link/CustomLink';
import { GlobalClassName } from '@/shared/constant/GlobalClassName';
import type { SidebarTreeDocNode } from '@/shared/constant/sidebar-tree/SidebarTreeNode';
import clsx from 'clsx';
import React from 'react';
import styles from '../../SidebarTree.module.css';
import { useSidebarTreeStore } from '../../store/sidebarTreeStore';
import { generateClassNameBySidebarTreeNodeKey } from '../../util/generateClassNameBySidebarTreeNodeKey';

export type SidebarDocProps = {
  value: SidebarTreeDocNode;
  isHidden: boolean;
};

export const SidebarDoc = React.memo(function SidebarDocComponent(props: SidebarDocProps) {
  const { value, isHidden } = props;

  const selected = useSidebarTreeStore((x) => x.selectedKey === value.key);
  const setSelectedKey = useSidebarTreeStore((x) => x.setSelectedKey);

  return (
    <li
      className={clsx(GlobalClassName.SidebarItemLink, {
        [GlobalClassName.SidebarItemLinkActive]: selected,
      })}
    >
      <CustomLink
        className={clsx(styles['sidebar-tree-node'], {
          [`${styles['sidebar-tree-node--selected']}`]: selected,
          ['font-600']: selected,
          [generateClassNameBySidebarTreeNodeKey(value.key)]: selected,
        })}
        isSampleLink={isHidden}
        sampleName={value.name}
        to={value.to}
        title={value.name}
        onClick={() => {
          setSelectedKey(value.key);
        }}
      >
        <span className="break-word">{value.name}</span>
      </CustomLink>
    </li>
  );
});
